angular.module('meevo.plugins.confirmationManager').controller('confirmationHistory', [
    '$scope',
	'$http',
	'$rootScope',
	'restServer',
	'appointmentBookModalService',
	'appointmentId',
	'meevo.AppSettings',
    (
		$scope,
		$http,
		$rootScope,
		restServer,
		modal,
		appointmentId,
		appSettings: Meevo.Components.Common.IAppSettings
	) => {
	    $scope.modal = modal;
	    $scope.service = {}

	    if (appointmentId != undefined) {
		    restServer.getAppointmentAuditHistory(appointmentId, appSettings, response => {
			    $scope.service = response;
		    });
	    }
    }
]);